<template>
  <div>
    <px-view-header title="Solicitações" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <div class="mt-5">
      <listagem-requisicao-header :on-click-refresh="onClickRefresh"
                                  :on-change-filter="onChangeFilter"
                                  @change="onChangeFilter"/>
      <lista-requisicao :requisicoes="requisicoes" :loading="loading"
                        :on-change-options="onChangeOptions"
                        :options-list="optionsList"
                        :footer-options="footerOptions"
                        @update="onClickRefresh"
                        @remove="onRemove"
                        @cancelar="onCancelar"/>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  RESET_PAGINATION,
  SET_FILTER_ACTION,
  SET_LIST_OPTIONS_ACTION,
  INIT_STATE_ACTION,
  SET_CURRENT_SESSION_STATE_ACTION,
} from '@/store/listagem-requisicao/actions.type';
import paginationMixin from '@/mixins/pagination-mixin';
import ListagemRequisicaoHeader from '@/modules/requisicao/listagem/ListagemRequisicaoHeader.vue';
import ListaRequisicao from '@/modules/requisicao/listagem/ListaRequisicao.vue';
import RequisicaoService from '../requisicoes-service';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      requisicoes: {
        content: [],
        total: 0,
      },
      loading: false,
      breadcrumbs: [
        { text: 'Gestão de compras' },
        { text: 'Solicitações' },
      ],
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemRequisicao', ['stringFilter', 'listOptions']),
    ...mapGetters('entidade', ['idEntidade']),
    ...mapGetters('user', ['user']),
  },
  methods: {
    ...mapActions('listagemRequisicao', {
      resetPagination: RESET_PAGINATION,
      updateFilter: SET_FILTER_ACTION,
      updateOptions: SET_LIST_OPTIONS_ACTION,
      initState: INIT_STATE_ACTION,
      setCurrentSessionState: SET_CURRENT_SESSION_STATE_ACTION,
    }),
    onChangeFilter() {
      this.updateFilter(this.stringFilter);
      this.resetPage();
      this.getRequisicoes();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.updateOptions(this.optionsToPage(this.listOptions, this.optionsList));
      this.getRequisicoes();
    },
    onClickRefresh() {
      this.getRequisicoes();
    },
    resetPage() {
      this.resetPagination();
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    onRemove(id) {
      this.loading = true;
      RequisicaoService.excluirRascunho(id)
        .then(() => {
          this.$toast('Rascunho excluido com sucesso', { color: 'success' });
          this.getRequisicoes();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getRequisicoes() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return RequisicaoService.getRequisicoes({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.requisicoes = response.data;
        })
        .finally(() => {
          this.setCurrentSessionState({
            idCurrentEntidade: this.idEntidade,
            idCurrentUser: this.user.id,
          });
          this.loading = false;
        });
    },
    onCancelar(id, motivoRecusa) {
      this.loading = true;
      RequisicaoService.cancelar(id, motivoRecusa)
        .then(() => {
          this.$toast('Requisicao cancelada com sucesso', { color: 'success' });
          this.getRequisicoes();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.initState({
      idCurrentEntidade: this.idEntidade,
      idCurrentUser: this.user.id,
    });
    this.optionsList = this.pageToOptions(this.listOptions);
  },
  components: {
    ListagemRequisicaoHeader,
    ListaRequisicao,
  },
};
</script>
